module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-44.d54d8b01.png";